import { languageOptions } from '@/constants';
import { useAddLanguageMutation } from '@/redux/api/api.caller';
import { ILanguageList } from '@/types/language';
import { Modal, Text } from '@shopify/polaris';
import { useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { handleMutationResult } from '../../toastResult';
import LanguageAutocomplete from '../LanguageAutocomplete';

interface Props {
  open: boolean;
  onClose: () => void;
  list: ILanguageList;
}

const AddLanguageModal = ({ open, onClose, list }: Props) => {
  const dispatch = useDispatch();
  const [addLanguage, { isLoading }] = useAddLanguageMutation();
  const existing = useMemo(() => new Set(list.languages.map((l) => l.language)), [list.languages]);
  const options = useMemo(() => languageOptions.filter((o) => !existing.has(o.value)), [existing]);
  const [selected, setSelected] = useState<string>('');

  const onSubmit = () => {
    if (!selected) return;
    addLanguage({ language: selected }).then((res: any) => {
      if (handleMutationResult(dispatch, res)) {
        setSelected('');
        onClose();
      }
    });
  };

  return (
    <Modal
      open={open}
      title="Add a language"
      onClose={onClose}
      primaryAction={{ content: 'Add', onAction: onSubmit, loading: isLoading, disabled: !selected }}
      secondaryActions={[{ content: 'Cancel', onAction: onClose }]}
    >
      <Modal.Section>
        {options.length === 0 ? (
          <Text as="p" variant="bodyMd">
            All supported languages have already been added.
          </Text>
        ) : (
          <LanguageAutocomplete label="Language" options={options} selected={selected} onChange={setSelected} />
        )}
      </Modal.Section>
    </Modal>
  );
};

export default AddLanguageModal;
